module.exports = __webpack_public_path__ + "img/Personal.d2b3db26.svg";